export default __webpack_public_path__ + "static/media/Rerebrace of the Blood Drinker.a06a0bf0.jpg";